/* eslint sort-keys: "error" */
/* eslint-env es6 */

const AfsProductCareOnArgosFeatures = {
  ASK_QUESTION: true,
  ATT_MODAL_HIDE_CATEGORIES: false,
  ATT_MODAL_HIDE_EXTRAS: false,
  BASE_URL: 'www.argos.co.uk',
  BREADCRUMB: false,
  BV_WRITE_REVIEW: false,
  CATEGORY_EXPERIENCES_TEMPLATE_ENABLED: false,
  CNET: true,
  COMPARISON_ATTRIBUTES: false,
  COMPLETE_THE_LOOK: false,
  CUSTOMER_GENERATED_CONTENT: false,
  DESCRIPTION_CLASS: 'xs-12--none md-7--none xl-8--none',
  EMAIL_ME_BACK: {
    enabled: false
  },
  ENERGY_SAVING: false,
  ESSENTIAL_EXTRAS: true,
  FABLE_ATT: false,
  FEATURED_PRODUCTS: true,
  FREQUENTY_BROUHT_TOGETHER: true,
  GO_IN_STORE: false,
  MEDIA_CLASS: 'xs-12--none md-7 xl-8',
  MEDIA_PORTRAIT: false,
  MONTHLY_PAYMENT_PLAN: true,
  NECTAR: true,
  PAYPAL_MESSAGING: true,
  PDP_V2_ENABLED: true,
  PRICING_CLASS: 'xs-12--none md-5--none xl-4--none',
  Q_AND_A: true,
  REVIEWS: false,
  REVIEWS_WRITE_REVIEW_ENABLED: false,
  SHOP_COLLECTION: false,
  SHOP_THE_LOOK: {
    SHOP_THE_LOOK_ENABLED: false
  },
  SIMILAR_ITEMS: false,
  SOLD_BY_ARGOS: false,
  SPECIFICATION_TABLE: false,
  STICKY_BAR: true,
  SYTE: {
    SYTE_ACCOUNT_ID: '9131',
    SYTE_BUTTON: false,
    SYTE_SIGNATURE: '5fff26234bfaae662930581f'
  },
  TEMPLATE_TYPE: 'AFS',
  WISHLIST: true
}

export default AfsProductCareOnArgosFeatures
